<div class="filter-container">
  <div class="row">
    <div class="filter-window col-12">
      <div class="row">
        <div class="title-header col-12">
          <i class="fa fa-filter" aria-hidden="true"></i> <span class="title">{{ 'ORDERS.FILTER.TITLE' | translate }}</span>
          <span class="subtitle">{{ 'ORDERS.FILTER.SUBTITLE' | translate }}</span>
        </div>
      </div>

      <div class="row">
        <div class="form-container col-12 row">
          <form [formGroup]="filterForm" class="row col-12">
            <div class="col-12 col-md-6">
              <div class="cell col-12 form-group row" *ngIf="customers">
                <eps-select
                  [options]="customers"
                  label="ORDERS.FILTER.LABELS.CUSTOMERS"
                  formControlName="customers"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell col-12 form-group row">
                <eps-select
                  [options]="filterValues.orderTypes"
                  label="ORDERS.FILTER.LABELS.ORDER_TYPE"
                  formControlName="orderTypes"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell col-12 form-group row">
                <eps-select
                  [options]="filterValues.shippingConditions"
                  label="ORDERS.FILTER.LABELS.SHIPPING_CONDITION"
                  formControlName="shippingCondition"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell col-12 form-group row">
                <eps-select
                  label="ORDERS.FILTER.LABELS.FROM"
                  [options]="filterValues.froms"
                  formControlName="froms"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell col-12 form-group row">
                <eps-select
                  [options]="filterValues.tos"
                  label="ORDERS.FILTER.LABELS.TO"
                  formControlName="tos"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell col-12 form-group row" *ngIf="!customers">
                <eps-select
                  [options]="shipTos"
                  label="ORDERS.FILTER.LABELS.SHIPTO"
                  formControlName="shipTos"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell col-12 form-group row">
                <eps-select
                  [options]="filterValues.incoterms"
                  label="ORDERS.FILTER.LABELS.INCOTERM"
                  formControlName="incoterms"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell col-12 form-group row" *ngIf="showAdvanced">
                <eps-select
                  [options]="definitions.order.status"
                  label="ORDERS.FILTER.LABELS.ORDER_STATUS"
                  formControlName="orderStatuses"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell col-12 form-group row" *ngIf="showAdvanced">
                <eps-select
                  [options]="filterValues.pallets"
                  label="ORDERS.FILTER.LABELS.PALLET_ID"
                  formControlName="palletIds"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <div class="cell col-12 form-group row" *ngIf="showAdvanced">
                <eps-select
                  [options]="filterValues.packings"
                  label="ORDERS.FILTER.LABELS.PACKING_ID"
                  formControlName="packingIds"
                  autoSelect
                  multiple
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-select>
              </div>
              <ng-container *ngIf="(showDatesIn2rows$ | async)">
                <div class="cell col-12 form-group row">
                  <eps-text-input
                    label="ORDERS.FILTER.LABELS.RECEIVER_REFERENCE_NUMBER"
                    formControlName="customerReferenceNumber"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
                <div class="cell col-12 form-group row">
                  <eps-text-input
                    label="ORDERS.FILTER.LABELS.SENDER_REFERENCE"
                    formControlName="senderReferenceNumber"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
              </ng-container>
              <div class="cell col-12 form-group row">
                <eps-label-body label="ORDERS.FILTER.LABELS.CCR">
                  <div class="checkboxes">
                    <eps-checkbox
                      [showErrors]="false"
                      labelPosition="none"
                      checkboxLabel="SHARED.BUTTONS.YES"
                      formControlName="ccrYes"
                      hideOptionalMarker
                    ></eps-checkbox>&nbsp;&nbsp;&nbsp;
                    <eps-checkbox
                      [showErrors]="false"
                      labelPosition="none"
                      checkboxLabel="SHARED.BUTTONS.NO"
                      formControlName="ccrNo"
                      hideOptionalMarker
                    ></eps-checkbox>
                  </div>
                </eps-label-body>
              </div>
            </div>

            <div class="col-12 col-md-6">
              <ng-container *ngIf="(showDatesIn2rows$ | async); else showOrderDatesIn1row">
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="florderDateFrom"
                    label="ORDERS.FILTER.LABELS.ORDER_DATE_FROM"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
                <div class="cell col-12 form-group row">
                  <eps-date-input
                    formControlName="florderDateTo"
                    label="ORDERS.FILTER.LABELS.ORDER_DATE_TO"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-date-input>
                </div>
              </ng-container>
              <ng-template #showOrderDatesIn1row>
                <div class="cell col-12 form-group row">
                  <eps-label-body label="ORDERS.FILTER.LABELS.ORDER_DATE">
                    <div class="eps-body">
                      <eps-date-input
                        formControlName="florderDateFrom"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                      <eps-date-input
                        formControlName="florderDateTo"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                    </div>
                  </eps-label-body>
                </div>
              </ng-template>
              <ng-container *ngIf="(showDatesIn2rows$ | async); else showDefinitiveDatesIn1row">
                  <div class="cell col-12 form-group row">
                    <eps-date-input
                      formControlName="florderDefinitiveDateFrom"
                      label="ORDERS.FILTER.LABELS.DEFINITIVE_DATE_FROM"
                      [showErrors]="false"
                      hideOptionalMarker
                    ></eps-date-input>
                  </div>
                  <div class="cell col-12 form-group row">
                    <eps-date-input
                      formControlName="florderDefinitiveDateTo"
                      label="ORDERS.FILTER.LABELS.DEFINITIVE_DATE_TO"
                      [showErrors]="false"
                      hideOptionalMarker
                    ></eps-date-input>
                  </div>
              </ng-container>
              <ng-template #showDefinitiveDatesIn1row>
                <div class="form-group cell row col-12">
                  <eps-label-body label="ORDERS.FILTER.LABELS.DEFINITIVE_DATE">
                    <div class="eps-body">
                      <eps-date-input
                        formControlName="florderDefinitiveDateFrom"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                      <eps-date-input
                        formControlName="florderDefinitiveDateTo"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                    </div>
                  </eps-label-body>
                </div>
              </ng-template>
              <ng-container *ngIf="(showDatesIn2rows$ | async); else showUnloadingDatesIn1row">
                  <div class="cell col-12 form-group row">
                    <eps-date-input
                      formControlName="unloadingDateFrom"
                      label="ORDERS.FILTER.LABELS.UNLOADING_DATE_FROM"
                      [showErrors]="false"
                      hideOptionalMarker
                    ></eps-date-input>
                  </div>
                  <div class="cell col-12 form-group row">
                    <eps-date-input
                      formControlName="unloadingDateTo"
                      label="ORDERS.FILTER.LABELS.UNLOADING_DATE_TO"
                      [showErrors]="false"
                      hideOptionalMarker
                    ></eps-date-input>
                  </div>
              </ng-container>
              <ng-template #showUnloadingDatesIn1row>
                <div class="cell col-12 form-group row">
                  <eps-label-body label="ORDERS.FILTER.LABELS.UNLOADING_DATE">
                    <div class="eps-body">
                      <eps-date-input
                        formControlName="unloadingDateFrom"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                      <eps-date-input
                        formControlName="unloadingDateTo"
                        labelPosition="none"
                        [showErrors]="false"
                        hideOptionalMarker
                      ></eps-date-input>
                    </div>
                  </eps-label-body>
                </div>
              </ng-template>
              <ng-container *ngIf="!(showDatesIn2rows$ | async)">
                <div class="cell col-12 form-group row">
                  <eps-text-input
                    label="ORDERS.FILTER.LABELS.RECEIVER_REFERENCE_NUMBER"
                    formControlName="customerReferenceNumber"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
                <div class="cell col-12 form-group row">
                  <eps-text-input
                    label="ORDERS.FILTER.LABELS.SENDER_REFERENCE"
                    formControlName="senderReferenceNumber"
                    [showErrors]="false"
                    hideOptionalMarker
                  ></eps-text-input>
                </div>
              </ng-container>
              <div class="cell col-12 form-group row">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.SALES_ORDER_NUMBER"
                  formControlName="salesOrderNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell col-12 form-group row">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.ETM_DOCUMENT_NUMBER"
                  formControlName="etmDocumentNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell col-12 form-group row" *ngIf="showAdvanced">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.SEAL_NUMBER"
                  formControlName="sealNumber"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
              <div class="cell col-12 form-group row" *ngIf="showAdvanced">
                <eps-text-input
                  label="ORDERS.FILTER.LABELS.TRANSPORTER"
                  formControlName="transporter"
                  [showErrors]="false"
                  hideOptionalMarker
                ></eps-text-input>
              </div>
            </div>
          </form>

          <div class="row col-12 filter-buttons">
            <eps-button
              [disabled]="filterForm.disabled"
              (buttonClick)="showAdvanced = true"
              type="link"
              *ngIf="!showAdvanced"
              label="ORDERS.FILTER.BUTTONS.MORE_SEARCH_OPTIONS"
            ></eps-button>
            <eps-button
              [disabled]="filterForm.disabled"
              (buttonClick)="showAdvanced = false"
              type="link"
              *ngIf="showAdvanced"
              label="ORDERS.FILTER.BUTTONS.LESS_SEARCH_OPTIONS"
            ></eps-button>
            <eps-button
              [disabled]="filterForm.disabled"
              (buttonClick)="resetFilter()"
              buttonIcon="eraser"
              minWidth="160px"
              label="SHARED.BUTTONS.CLEAR_FILTERS"
            ></eps-button>
            <eps-button
              [disabled]="filterForm.invalid || filterForm.disabled"
              [busy]="isLoading"
              (buttonClick)="filterClicked()"
              type="primary"
              minWidth="160px"
              buttonIcon="filter"
              submit
              label="ORDERS.FILTER.BUTTONS.FILTER_TEXT"
            ></eps-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
